import { type ThunkDispatch } from "@reduxjs/toolkit"
import { type ApiResponse } from "apisauce"
import { type UnknownAction } from "redux"

import { errorSave } from "../../redux/errors.slice"

export const rejectWithMessage = (
  response: ApiResponse<any, any>,
  dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
  rejectWithValue: (value: any) => any
) => {
  const data = response?.data
  const message =
    data?.detail ||
    data?.message ||
    data?.message?.detail ||
    data?.details?.message ||
    null

  dispatch(errorSave(message))
  return rejectWithValue(response.data)
}
